import React, { FC, useMemo, useCallback, memo } from 'react';
import { useLazyQuery } from '@apollo/client';
import _sortBy from 'lodash/sortBy';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import ErrorMessage from '@minecraft.error-message';
import { QUERY_PROJECT_TYPES } from '../FilterBasicCollectionGraphQL';
import { generateSelectOptionsBasedOnField, getFilteredArrayByEnabled } from '../../../shared/utils';
import { FilterData } from '../../../shared/types';

type Props = FilterData;

const ProjectType: FC<Props> = ({ name, label }) => {
  const [getProjectType, { data, loading, error }] = useLazyQuery(QUERY_PROJECT_TYPES);

  const handleProjectTypeFetch = useCallback((): void => {
    if (!data) {
      getProjectType();
    }
  }, [data]);

  const noParents = data?.projectTypes?.filter((o) => o.parentObject);

  const projectTypeOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      _sortBy(getFilteredArrayByEnabled(noParents), 'sortOrder'),
      'name',
      false,
      undefined,
      true
    );
  }, [data]);

  if (error) return <ErrorMessage error={error} />;

  return (
    <DropdownWithChildren
      withFormik
      withSelectAll
      isLoading={loading}
      name={name}
      toggleLabel={label}
      options={projectTypeOptions}
      onOptionsFetch={handleProjectTypeFetch}
    />
  );
};

export default memo(ProjectType);
